import React from 'react'
import { Label } from 'reactstrap'
import { Button, Input } from 'antd'
import './StepFourPage.scss'
import { ArrowRightOutlined } from '@ant-design/icons'

const StepFourPage = ({ next }) => {
    const { TextArea } = Input;
    return (
        <div className='step4-section'>
            <h1>What is your <strong>vision?</strong></h1>
            <form>
                <div className="form-field">
                    <Label>What could this become in 5 years?</Label>
                    <TextArea rows={6} className="textarea-field-input"
                        placeholder="The non-profit one-stop shop.  "
                        name="what-in5-years"
                        type="textarea" />
                </div>
                <Button
                    // loading={authLoading}
                    // disabled={!isEnabled}
                    onClick={next}
                    className="continue-button"
                >
                    Continue <ArrowRightOutlined />
                </Button>
            </form>
        </div>
    )
}

export default StepFourPage